export const SEARCH_LIST = "SEARCH_LIST"
export const SEARCH_LIST_SUCCESS = "SEARCH_LIST_SUCCESS"
export const SEARCH_LIST_ERROR = "SEARCH_LIST_ERROR"

export const SEARCH_DOWNLOAD = "SEARCH_DOWNLOAD"
